import React from 'react'

/**
 * The Open / Past tab row that sits inside the centered page container,
 * below the filter panel. Split from `TasksPageHeader` (which stays
 * full-width) so the tabs can live inside the 720px column.
 *
 * Uses role="tablist" / role="tab" rather than SegmentedToggle because
 * the ARIA semantics are different — see the comment on the original
 * inline implementation.
 */
export function TasksTabs({ tab, onTabChange, openCount, pastCount }) {
  return (
    <div role="tablist" aria-label="Tasks filter" style={styles.tabs}>
      <button
        type="button"
        role="tab"
        aria-selected={tab === 'open'}
        onClick={() => onTabChange('open')}
        style={tab === 'open' ? { ...styles.tab, ...styles.tabActive } : styles.tab}
      >
        Open ({openCount})
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={tab === 'past'}
        onClick={() => onTabChange('past')}
        style={tab === 'past' ? { ...styles.tab, ...styles.tabActive } : styles.tab}
      >
        Past ({pastCount})
      </button>
    </div>
  )
}

const styles = {
  tabs: {
    display: 'flex',
    gap: 6,
  },
  tab: {
    fontSize: 12,
    padding: '6px 12px',
    borderRadius: 'var(--radius-pill)',
    border: '1px solid var(--border)',
    background: 'transparent',
    color: 'var(--text-secondary)',
    cursor: 'pointer',
  },
  tabActive: {
    background: 'var(--text-primary)',
    color: 'var(--surface)',
    borderColor: 'var(--text-primary)',
  },
}
